/**
 * GA360 트래킹 코드를 적용하기 위한,
 * 파일.
 */
export const DATA_CONTENTS = 'data-content';
export const DATA_AREA = 'data-area';

export const ga360 = {
    dataContents: {
        copy: 'URL 복사 공유하기',
        faceboodk: '페이스북 공유하기',
        twitter: '트위터 공유하기',
        line: '라인 공유하기',
    },
    dataArea: {
        common: '공유하기 클릭'
    }
};
